var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{attrs:{"value":_vm.checked,"indeterminate":_vm.isIndeterminate},on:{"change":_vm.handleChange}},[_vm._v(_vm._s(_vm.value.node_name))])}
var staticRenderFns = []

export { render, staticRenderFns }